/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check how easy your writing is to read. Paste text to get its Flesch Reading Ease score, grade level, and a full count of words, sentences, and syllables.`)
};

const es_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica qué tan fácil es leer tu escritura. Pega un texto para obtener su puntuación Flesch Reading Ease, nivel de grado, y un conteo completo de palabras, oraciones y sílabas.`)
};

const de_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie, wie leicht sich Ihr Text lesen lässt. Fügen Sie Text ein, um den Flesch Reading Ease-Wert, die Klassenstufe sowie eine vollständige Zählung von Wörtern, Sätzen und Silben zu erhalten.`)
};

const nl_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer hoe gemakkelijk uw tekst te lezen is. Plak tekst om de Flesch Reading Ease-score, graadniveau en een volledig aantal woorden, zinnen en lettergrepen te verkrijgen.`)
};

const fr_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez la facilité de lecture de votre texte. Collez votre texte pour obtenir son score Flesch Reading Ease, son niveau scolaire et un décompte complet des mots, phrases et syllabes.`)
};

const it_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica quanto è facile leggere la tua scrittura. Incolla il testo per ottenere il punteggio Flesch Reading Ease, il livello scolastico e un conteggio completo di parole, frasi e sillabe.`)
};

const pt_br2_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique o quão fácil é ler sua escrita. Cole o texto para obter sua pontuação Flesch Reading Ease, nível de série e uma contagem completa de palavras, sentenças e sílabas.`)
};

const pt_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique o quão fácil é ler o seu texto. Cole o texto para obter a sua pontuação Flesch Reading Ease, nível de escolaridade, e uma contagem completa de palavras, frases e sílabas.`)
};

const ja_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章がどのくらい読みやすいかを確認します。テキストを貼り付けると、Flesch Reading Easeスコア、グレードレベル、単語数、文数、音節数が表示されます。`)
};

const zh_ra_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查你的文章有多容易阅读。粘贴文本即可获取其 Flesch Reading Ease 分数、年级水平，以及完整的字数、句数和音节数统计。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_intro", locale)
	if (locale === "en") return en_ra_intro(inputs)
	if (locale === "es") return es_ra_intro(inputs)
	if (locale === "de") return de_ra_intro(inputs)
	if (locale === "nl") return nl_ra_intro(inputs)
	if (locale === "fr") return fr_ra_intro(inputs)
	if (locale === "it") return it_ra_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ra_intro(inputs)
	if (locale === "pt") return pt_ra_intro(inputs)
	if (locale === "ja") return ja_ra_intro(inputs)
	return zh_ra_intro(inputs)
};